import React from 'react';

import { DateObject } from '@uplift/services';

import { ActivityFeedGroupTitle } from './ActivityFeedGroupTitle.component';

export type ActivityFeedGroupProps<T> = {
  now: DateObject;
  items: T[];
  prevItems?: T[];
  getDate: (item: T) => string;
  getKey: (item: T) => string;
  renderItem: (item: T) => React.ReactNode;
};

export const ActivityFeedGroup = <T,>({ now, items, prevItems, getDate, getKey, renderItem }: ActivityFeedGroupProps<T>) => {
  return (
    <>
      {items.map((item, index, arr) => {
        const prevDate = index === 0
          ? prevItems?.[prevItems.length - 1] && getDate(prevItems[prevItems.length - 1])
          : getDate(arr[index - 1]);

        return (
          <React.Fragment key={getKey(item)}>
            <ActivityFeedGroupTitle date={getDate(item)} prevDate={prevDate} now={now} />
            {renderItem(item)}
          </React.Fragment>
        );
      })}
    </>
  );
};
